import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
import { AuthorWatchButton } from '../../../Button';
import { getBlockBI } from '../../helpers';
import SeeAllLink from '../SeeAllLink';
import MoreByAuthor from '../MoreByAuthor';
import s from './SidebarBlockWrapper.scss';
var SidebarBlockWrapper = function (_a) {
    var _b;
    var deviation = _a.deviation, _c = _a.block, contentType = _c.contentType, _d = _c.seeAllType, seeAllType = _d === void 0 ? 'seeall' : _d, seeAllUrl = _c.seeAllUrl, _e = _c.titleType, titleType = _e === void 0 ? 'plaintext' : _e, children = _a.children, className = _a.className, headerClassName = _a.headerClassName, titleClassName = _a.titleClassName, seeAllClassName = _a.seeAllClassName, onSeeAllClick = _a.onSeeAllClick;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var showSeeAllLink = !!seeAllUrl || !!onSeeAllClick;
    var author = deviation.author;
    var currentUser = useCurrentUser();
    var isDisplayingAnotherUsersMoreBy = !showSeeAllLink &&
        titleType === 'more-by' &&
        author &&
        (author === null || author === void 0 ? void 0 : author.userId) !== currentUser.userId;
    return (React.createElement(BiLoggerContextProvider, { value: getBlockBI(contentType) },
        React.createElement("div", { className: classnames(s['root'], className) },
            React.createElement("div", { className: classnames(s['block-header'], headerClassName) },
                React.createElement("span", { className: classnames(s['block-title'], titleClassName) }, titleType === 'more-by' && deviation.author ? (React.createElement(MoreByAuthor, { author: deviation.author, contentType: contentType })) : (t("sidebar.blockTitle.".concat(contentType), {
                    author: (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.username,
                }))),
                showSeeAllLink && (React.createElement(SeeAllLink, { contentType: contentType, deviation: deviation, type: seeAllType, url: seeAllUrl, onClick: onSeeAllClick, className: classnames(s['see-all'], seeAllClassName) })),
                !isMobile && isDisplayingAnotherUsersMoreBy && (React.createElement(AuthorWatchButton, { author: author }))),
            children)));
};
SidebarBlockWrapper.displayName = 'SidebarBlockWrapper';
export default SidebarBlockWrapper;
//# sourceMappingURL=SidebarBlockWrapper.js.map